import { getStore, setStore, removeStore } from "./store";

const adminId = "ADMIN-ID";
const adminToken = "ADMIN-TOKEN";

// GEt token
export function getToken() {
    return getStore(adminToken);
}

// set uptoken
export function setToken(sid) {
    return setStore(adminToken, sid, 365);
}

// deletetoken
export function removeToken() {
    return removeStore(adminToken);
}

// Get admin_id
export function getAdminId() {
    return getStore(adminId);
}

// set up admin_id
export function setAdminId(id) {
    return setStore(adminId, id, 365);
}

// delete admin_id
export function removeAdminId() {
    return removeStore(adminId);
}